import colors from 'quasar/src/utils/colors.js';

const { getPaletteColor, lighten, changeAlpha, luminosity, brightness } = colors

export {getPaletteColor, lighten, changeAlpha, luminosity, brightness}